import BaseBlockMap from './BaseBlockMap';
import CalculatorsMtgBlockMap from './CalculatorsmtgBlockMap';


export default {
    ...BaseBlockMap,
    ...CalculatorsMtgBlockMap,
};
